import { getReadOnlyMode } from '../../services/session/api';

export const getIsReadOnlyModeActive = (): boolean => getReadOnlyMode();
